import ActionTypes from './actionTypes';

export const fetch = (from, to, shipperId, courierAccountId) => ({
  type: ActionTypes.FETCH,
  payload: {
    from,
    to,
    shipperId,
    courierAccountId,
  },
});

export const fetched = (data) => ({
  type: ActionTypes.FETCHED,
  payload: {
    data,
  },
});

export const generate = (from, to, shipperIds, courierAccountId) => ({
  type: ActionTypes.GENERATE,
  payload: {
    from,
    to,
    shipperIds,
    courierAccountId,
  },
});

export const generated = () => ({
  type: ActionTypes.GENERATED,
  payload: {},
});

export const download = (from, to, shipperId, courierAccountId) => ({
  type: ActionTypes.DOWNLOAD,
  payload: {
    from,
    to,
    shipperId,
    courierAccountId,
  },
});

export const downloaded = () => ({
  type: ActionTypes.DOWNLOADED,
  payload: {},
});
